

import { NotificationService } from "@/services/NotificationService";
import { UserService } from "@/services/UserService";
import { defineComponent } from "vue";
import { container } from "tsyringe";

const jQuery = require('jquery');

const isEnabledTwoFormFactorAuth = process.env.VUE_APP_2FA_ENABLED == 1;

export default defineComponent({
  
  data() {
    return {
      ic: "",
      pin: "",
      remember: false,
      errorMessage: null,
    };
  },

  created() {
    if (this.$route.query.logout) {
      let userService = container.resolve(UserService);
      userService.logout();
    }
  },

  mounted() {
    jQuery("#pinquestion").kendoTooltip();
  },

  methods: {
    async login() {

      let userService = container.resolve(UserService);
      let notificationService = container.resolve(NotificationService);

      let result = await userService.login(this.ic, this.pin, this.remember, notificationService.token);

      if (!result.userId) {
        this.errorMessage = "Chyba přihlášení";
        return;
      }

      if(isEnabledTwoFormFactorAuth && result.userId && result.verificationNumber === "sent"){
        this.$router.push("/verification?id=" + result.userId + "&remember=" + result.remember);
      }else{
        this.$router.push("/");
      }
    }
  }

});
